<template>
  <div>
    <h1>{{section.name}}</h1>
    <p>{{section.description}}</p>
    <ul>
      <SPItem v-for="item in section.items" :key="item.id" :item="item"/>
    </ul>
  </div>
</template>

<script>
import SPItem from "./SPItem.vue";

export default {
  props: ["section"],
  components: {
    SPItem
  }
};
</script>
